// extracted by mini-css-extract-plugin
export default {"div":"ReviewsWrite_div__Lpd7c","main":"ReviewsWrite_main__-m10D"};